import { Accordion, Image, Row, Col } from 'react-bootstrap';

import python from '../img/certificates/UC-b865f4ff-9069-4915-a4fb-d53c33314f76.jpg';
import django from '../img/certificates/UC-5eecda9d-1496-4171-b975-03fc639276ae - django.jpg';
import wordpress from '../img/certificates/UC-9326b69c-4016-492c-9f22-2f7e98c606f4.jpg';
import wordpressapi from '../img/certificates/UC-ce60b19f-c3ab-411d-8e1c-37db9840afd7 - WordPress + API.jpg';


function Certificates() {

  return (
    <Accordion>
      <Accordion.Item eventKey="1">
        <Accordion.Header>
          <h4>Wordpress</h4>
        </Accordion.Header>
        <Accordion.Body>
          <Row>
            <Col>
              Wordpress  API
              <Image fluid src={wordpressapi} />
            </Col>
            <Col>
              Wordpress
              <Image fluid src={wordpress} />
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="0">
        <Accordion.Header>
          <h4>Python</h4>
        </Accordion.Header>
        <Accordion.Body>
          <Row>
            <Col>
              Django
              <Image fluid src={django} />
            </Col>
            <Col>
              Python
              <Image fluid src={python} />
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}

export default Certificates;